<div class="results-management">
    @if (isLoading()) {
        <div class="policy-spinner">
            <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
        </div>
    }

    <div class="results-management-tabs-section">
        <div class="tabs-titles">
            @if (tabs.length > 0) {
                <app-sidepanel-tabs
                    [tabs]="tabs"
                    [currentTabIndex]="currentTabIndex"
                    (tabOnSelection)="onUserTabSelect($event)">
                </app-sidepanel-tabs>
            }
        </div>
        <div class="divider"></div>
    </div>
    @switch (currentTabIndex) {
        @case (0) {
            <div class="subtitle">
                <span [innerHTML]="findingsSubtitlePath | labelsProvider"></span>
                <img
                    class="icon-field"
                    src="assets/images/common/info.svg"
                    height="16px"
                    [matTooltip]="findingsTooltipLabelPath | labelsProvider"
                    matTooltipPosition="above" />
            </div>
        }
        @case (1) {
            <div class="subtitle">
                <span [innerHTML]="activitySubtitlePath | labelsProvider"></span>
                <img
                    class="icon-field"
                    src="assets/images/common/info.svg"
                    height="16px"
                    [matTooltip]="activityTooltipLabelPath | labelsProvider"
                    matTooltipPosition="above" />
            </div>
        }
        @case (3) {
            <div class="subtitle">
                <span [innerHTML]="inLineControlSubtitlePath | labelsProvider"></span>
            </div>
        }
    }

    @if (isLoading() === false) {
        <div class="scollable-tables">
            @switch (currentTabIndex) {
                @case (0) {
                    <app-enterprise-ai-findings></app-enterprise-ai-findings>
                }
                @case (1) {
                    <app-enterprise-ai-activity></app-enterprise-ai-activity>
                }
                @case (2) {
                    @if (showPreventionMockTab) {
                        <app-enterprise-ai-prevention-mock></app-enterprise-ai-prevention-mock>
                    }  @else if (isAccountAuthorizedToViewDataInsights) {
                        <app-enterprise-ai-data-insights></app-enterprise-ai-data-insights>
                    }
                }
                @case (3) {
                    <app-enterprise-ai-in-line-control></app-enterprise-ai-in-line-control>
                }
            }
        </div>
    }
</div>
